import BooksitoutImages from "../images/BooksitoutImages";

const BooksitoutLogo = () => {
    return (
        <img src={BooksitoutImages.WebsiteLogo.booksitout} alt="" className="img-fluid" style={{ width: '35px', height: '35px', borderRadius: '8px' }} />
    )
}

export default BooksitoutLogo